import dayjs from "dayjs";

/**
 * Returns the Per Capita compliance deadline for the given year.
 * The deadline is June 30, but if that falls on a weekend it rolls
 * forward to the next Monday (July 1 or July 2).
 */
export const getPerCapitaDeadline = (year: number = dayjs().year()): string => {
  const june30 = dayjs().year(year).month(5).date(30);
  const day = june30.day(); // 0=Sun, 6=Sat
  if (day === 6) return "July 2";  // Saturday → Monday
  if (day === 0) return "July 1";  // Sunday → Monday
  return "June 30";
};
